import { Box, Skeleton, Typography } from '@mui/material'
import CollectionsOutlinedIcon from '@mui/icons-material/CollectionsOutlined'
import type { Theme } from '@mui/material/styles'
import { useCollectionViewContext } from './CollectionViewPageContext'

const iconSize = 20

export function CollectionName() {
  const { collection } = useCollectionViewContext()
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', alignSelf: 'flex-start', pl: 3 }}>
      <CollectionsOutlinedIcon
        sx={{
          width: iconSize,
          height: iconSize,
          color: (theme: Theme) => theme.palette.primary.main,
          mr: 0.5,
        }}
      />
      {collection ? (
        <Typography variant="h5"> {collection.name}</Typography>
      ) : (
        <Skeleton variant="text" sx={{ fontSize: '1.5rem', width: 160 }} />
      )}
    </Box>
  )
}
